import { useMediaQuery } from '@mui/material'
import { MobileCard } from './Mobile';
import { DesktopCard } from './Desktop';
import { PureLightTheme } from '../../../styles/theme';
import type { IGrowthToolListItem } from '../../../api/types/growthTools'

interface GrowthToolItemProps {
  growthTool: IGrowthToolListItem
}

export const GrowthToolItem = ({ growthTool }: GrowthToolItemProps) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down("sm"));

  return isMobile ? <MobileCard growthTool={growthTool} /> : <DesktopCard growthTool={growthTool} />;
}
